import { BaseColumn } from './base-column';
import template from './device-type.pug';
import { i18nMap, safeGetString } from '../../i18n-map/i18n-map';
import { isDataExclusion } from '../../adjustment-type';

export class DeviceTypeColumn extends BaseColumn {
  constructor(option) {
    const title = _TL_('Devices');

    super({
      name: 'Devices',
      title,
      i18n: option.i18n,
      property: ['DeviceTypeFilter'],
      sortable: 'DeviceTypeSort',
      helpId: isDataExclusion(option.adjustmentType) ? 'pop_BA_DataExclusions_Devices' : 'pop_BA_SeasonalityAdjustments_Devices',
      helpAriaLabel: option.i18n.getString(_TL_('Click to learn more about {{item}}'), { item: option.i18n.getString(title) }),
    });
  }

  template({
    value: {
      DeviceTypeFilter,
    },
  }) {
    let deviceTypeItems;
    if (DeviceTypeFilter) {
      const globalizedDeviceTypes = DeviceTypeFilter.map(item => (safeGetString(this.i18n, i18nMap.DeviceTypes, item)));
      deviceTypeItems = globalizedDeviceTypes.join(this.i18n.getString(_TL_(', ')));
    }

    const items = `${deviceTypeItems}`;

    return template({
      items,
    });
  }
}
